<div class="terms-wrapper">
    <div class="terms-content">
        <mat-icon class="float-right " mat-dialog-close>close</mat-icon>
        <h3>Ruralx Terms & Conditions</h3>
        <p class="last-updated">Last Updated: Oct 2026</p>

        <section>
            <h5>1. Introduction</h5>
            <p>
                Welcome to Ruralx. These Terms and Conditions govern your use of our mobile application,
                website, and services. By accessing or using Ruralx, you agree to comply with these terms.
                If you do not agree, please do not use our services.
            </p>
        </section>

        <section>
            <h5>2. Eligibility</h5>
            <p>By using Ruralx, you confirm that:</p>
            <ul>
                <li>You are at least 18 years old, OR</li>
                <li>You are using the platform under parental or guardian supervision</li>
            </ul>
        </section>

        <section>
            <h5>3. User Account & Security</h5>
            <p>Users may be required to create an account to place orders or access certain features.</p>
            <ul>
                <li>You must provide accurate and updated information</li>
                <li>You are responsible for maintaining account confidentiality</li>
                <li>You are responsible for all activities under your account</li>
            </ul>
        </section>

        <section>
            <h5>4. Product Information & Availability</h5>
            <p>We aim to provide accurate product descriptions, pricing, and images. However:</p>
            <ul>
                <li>Product colors may slightly vary due to lighting or display differences</li>
                <li>Handmade or textile products may have minor variations</li>
                <li>Products are subject to availability</li>
            </ul>
        </section>

        <section>
            <h5>5. Pricing & Payment</h5>
            <ul>
                <li>All prices are displayed in INR</li>
                <li>Prices may change without prior notice</li>
                <li>Orders are confirmed only after successful payment</li>
            </ul>
            <p>
                Ruralx reserves the right to cancel orders due to pricing errors, stock issues,
                or suspected fraudulent transactions.
            </p>
        </section>

        <section>
            <h5>6. Shipping & Delivery</h5>
            <ul>
                <li>Delivery timelines are estimated and not guaranteed</li>
                <li>Delays may occur due to courier or weather conditions</li>
                <li>Customers must provide correct delivery address and contact details</li>
            </ul>
        </section>

        <section>
            <h5>7. Returns & Refunds</h5>
            <p>Return requests are accepted in the following cases:</p>
            <ul>
                <li>Wrong product delivered</li>
                <li>Damaged product received</li>
                <li>Manufacturing defect</li>
            </ul>

            <p>
             Return requests must be raised within <strong>24 hours</strong> of delivery.
            </p>
            <p>
                After the returned product has been inspected and the refund approved,
                Ruralx will initiate the refund to the original payment method within
                <strong>5–7 business days</strong>. The time taken for the amount to appear
                in your account may depend on your bank or payment provider.
            </p>
        </section>

        <section>
            <h5>8. Non-Returnable Products</h5>
            <p>
                Certain products may not be eligible for return due to hygiene,
                safety or product-specific restrictions, except where a return,
                replacement or refund is required by applicable law.
            </p>
        </section>

        <section>
            <h5>9. Order Cancellation</h5>
            <p>
                Customers may request cancellation before the order is dispatched.
                Cancellation requests made after dispatch will be handled according
                to the order status and applicable policy.
            </p>
        </section>

        <section>
            <h5>10. User Conduct</h5>
            <p>Users agree not to:</p>
            <ul>
                <li>Use the platform for illegal activities</li>
                <li>Upload harmful or false content</li>
                <li>Attempt unauthorized access or hacking</li>
            </ul>
        </section>

        <section>
            <h5>11. Intellectual Property</h5>
            <p>
                All content on Ruralx including logos, product images, text, and design
                belongs to Ruralx and cannot be copied or reused without permission.
            </p>
        </section>

        <section>
            <h5>12. Limitation of Liability</h5>
            <p>
                Ruralx shall not be liable for indirect, incidental, or consequential damages
                arising from the use of our services or products.
            </p>
        </section>

        <section>
            <h5>13. Modification of Terms</h5>
            <p>
                Ruralx reserves the right to update or modify these Terms at any time.
                Continued use of the platform indicates acceptance of updated Terms.
            </p>
        </section>

        <section>
            <h5>14. Governing Law</h5>
            <p>
                These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the jurisdiction of the competent courts at Waraseoni, District Balaghat, Madhya Pradesh, India.
            </p>
        </section>

        <section>
            <h5>15. Contact Information</h5>
            <p>If you have questions regarding these Terms, contact us at:</p>
            <p>
                <strong>Email:</strong> info@ruralx.in<br>
                <strong>Company:</strong> Ruralx E-Trade Private Limited<br>
                <strong>Address:</strong> Ward No. 06, Nirmal Nagar, Railway Station Road,
                 Waresoni, Balaghat, Madhya Pradesh 481331, India
            </p>
        </section>

    </div>
</div>